import { RootState } from "@/redux/store";

export const newNotificationsSelector = (state: RootState) => state.notification.newNotifications;
export const earlierNotificationsSelector = (state: RootState) => state.notification.earlierNotifications;
export const notificationsPageSelector = (state: RootState) => state.notification.page;
